export const CollectionsTableColumns = [
    { id: 'titleEn', labelEn: 'English Title', labelAr: 'العنوان بالإنجليزي', align: 'start' },
    { id: 'titleAr', labelEn: 'Arabic Title', labelAr: 'العنوان بالعربي', align: 'start' },
    { id: 'type', labelEn: 'Type', labelAr: 'النوع', align: 'start' },
    { id: 'slug', labelEn: 'Slug', labelAr: 'اسم الرابط (Slug)', align: 'start' },
    { id: 'is_active', labelEn: 'Status', labelAr: 'الحالة', align: 'center' },
    { id: 'created_at', labelEn: 'Created At', labelAr: 'تاريخ الإضافة', align: 'start' },
];
